import React from 'react';
import useStore from '../store/useStore';


const ColumnVisibleSessions = () => {

    const {

        eventId,
        displaycolumnssessions

    } = useStore((state: any) => ({

        eventId: state.settings.params.eventid,
        displaycolumnssessions: state.settings.params.displaycolumnssessions,

    }));

    /*const SOCIAL_EVENT_COLUMNS = {
        MonitorTitle: true,
        TimeSessionStartEnd: true,
        DateSession: true,
        RoomName: true,
        Building: true,
        MeetingType: false,
        Message: true, //important
        Notes: true, //important
        CalendarDate: false,
        actions: false, //important
    };*/


    /* MonitorTitle: 1, TimeSessionStartEnd: 1,
      DateSession: 1, AgendaItems: 1, 
      CommitteeSubGroup: 1, RoomName: 1, Building: 1,
       MeetingType: 1, Message: 0, Notes: 0,
        CalendarDate: 0, actions: 1 */

    const ALL_COLUMNS = {
        MonitorTitle: Boolean(displaycolumnssessions?.MonitorTitle),
        TimeSessionStartEnd: Boolean(displaycolumnssessions?.TimeSessionStartEnd),
        DateSession: Boolean(displaycolumnssessions?.DateSession),
        AgendaItems: Boolean(displaycolumnssessions?.AgendaItems),
        CommitteeSubGroup: Boolean(displaycolumnssessions?.CommitteeSubGroup),
        RoomName: Boolean(displaycolumnssessions?.RoomName),
        Building: Boolean(displaycolumnssessions?.Building),
        MeetingType: Boolean(displaycolumnssessions?.MeetingType),
        Message: Boolean(displaycolumnssessions?.Message), //invitation to
        Notes: Boolean(displaycolumnssessions?.Notes),
        CalendarDate: Boolean(displaycolumnssessions?.CalendarDate),
        actions: Boolean(displaycolumnssessions?.actions),
    };

    /* let currentColumns = ALL_COLUMNS
     if (eventId !== undefined && eventId !== '') {
         //social events
         currentColumns = SOCIAL_EVENT_COLUMNS
     }*/



    //console.log(currentColumns)

    /*const [columnVisible, setColumnVisible] = React.useState(ALL_COLUMNS);
    React.useEffect(() => {
        const newColumns = currentColumns ? ALL_COLUMNS : SOCIAL_EVENT_COLUMNS;
        setColumnVisible(newColumns);
        console.log(columnVisible)
    }, [currentColumns]);*/


    return ALL_COLUMNS




};

export default ColumnVisibleSessions;